import { buildBusinessErrorFromError } from '@mgdis/eu-domain';
class MenuRestAdapter {
    tenantId;
    restHttpAdapter;
    /**
     * Menu API.
     */
    constructor({ tenantId, restHttpAdapter }) {
        this.tenantId = tenantId;
        this.restHttpAdapter = restHttpAdapter;
    }
    /**
     * Call API: count unreaded documents.
     *
     * @returns unreaded documents count
     */
    async getDocumentsCount() {
        try {
            const res = await this.restHttpAdapter.get(`/referentiel-publication-documents/api/tenants/${this.tenantId}/documents-publies/stats/my`, {
                headers: { 'x-referer': 'portail-depot-demande-aides' },
            });
            const response = res.data.unread ?? 0;
            return { response };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error) };
        }
    }
    /**
     * Call API: count unreaded echanges.
     *
     * @returns unreaded echanges count
     */
    async getEchangesCount() {
        try {
            const res = await this.restHttpAdapter.get(`/aides/api/tenants/${this.tenantId}/echanges`);
            const response = res.data.count ?? 0;
            return { response };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error) };
        }
    }
}
export { MenuRestAdapter };
//# sourceMappingURL=menu-rest.adapter.js.map